<div class="ngx-dropdown-container" tabindex="0">
  <button type="button" tabindex="-1" class="ngx-dropdown-button" [ngClass]="{ 'ngx-disabled': disabled }"
    [disabled]="disabled" (click)="toggleSelectDropdown()">
    <span class="display-text">{{ selectedDisplayText }} </span>
    <span class="nsdicon-angle-down"></span>
  </button>
  @if (toggleDropdown) {
    <div class="ngx-dropdown-list-container" [style.maxHeight]="config.height">
      @if (config.search) {
        <div class="search-container">
          <input #searchtext (change)="changeSearchText($event)" [style.direction]="config.inputDirection" name="search-text"
            (input)="searchTextChanged()" [(ngModel)]="searchText" tabindex="-1" autocomplete="off" />
            <label [ngClass]="{ active: searchText }">
              <span class="nsdicon-search"></span>
            {{ config.searchPlaceholder }}</label>
          </div>
        }
        <ul class="selected-items">
          @for (selected of selectedItems; track selected; let i = $index) {
            <li tabindex="-1" (click)="deselectItem(selected, i)">
              <span class="nsdicon-close">x</span>
              <span>
                {{
                config.listDisplayFn
                ? config.listDisplayFn(selected)
                : selected[config.displayKey] || selected
                }}
              </span>
            </li>
          }
        </ul>
        @if (selectedItems.length > 0 && availableItems.length > 0) {
          <hr />
        }
        <ul class="available-items">
          @for (
            item of availableItems
            | filterBy: searchText:config.searchOnKey
            | limitTo: config.limitTo; track
            item; let i = $index) {
<li #availableOption tabindex="-1" [ngClass]="{
            active: focusedItemIndex == i && !item.disabled,
            disabled: item.disabled
          }" (click)="selectItem(item, i)">
              {{
              config.listDisplayFn
              ? config.listDisplayFn(item)
              : item[config.displayKey] || item
              }}
            </li>
          }
          @if (showNotFound) {
            <li>{{ config.noResultsFound }}</li>
          }
        </ul>
      </div>
    }
  </div>